// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__om4lI","row":"styles_row__2gh8N"};